module.exports = __webpack_public_path__ + "img/logo.cc4e5589.png";